/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';
import { Breadcrumb, Button, Col, Dropdown, Form, Modal, NavItem, NavLink, Row } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { usePageTitle } from '../../../../../App';
import check_yellow_icon from '../../../../../assets/images/check-yellow-icon.svg';
import star_icon from '../../../../../assets/images/red-star-icon.svg';
import FAQ from '../../../../../assets/pdf/FAQ.pdf';
import { CustomTable, CustomTooltips } from '../../../../../components';
import { ALL_FILE_ROUTE, DASHBOARD_ROUTE } from '../../../../../constants/RouteNameConstants';
import { allFilesDashboardProofreaderTableData, myStatsTableData } from '../../../../../constants/TableHeaderConstants';
import { foreignLanguageTemplate, legalCategoryTemplate } from '../../../../../utils/TableCellUtils';
import { truncateString } from '../../../../../utils/TruncateStringUtils';
import { getUserInfo } from '../../../../../utils/UserInfoUtils';
import { myMetricsRequest, resetMyMetricsData } from '../../../MyMetrics/actions';
import RatingMetrics from '../../../MyMetrics/component/RatingMetrics';
import { proofreaderAllFilesRequest, proofreaderFilesFilterRequest } from '../actions';
import moment from 'moment';
import StatusDropdown from '../../MyFiles/component/StatusDropdown';
import { Badge } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { trackEvent } from '../../../../../utils/ga';

export const getDaysDiff = (dueDate) => {
  const today = moment();
  const due = moment(dueDate);
  const diff = due.diff(today, 'days');
  return diff;
};

const AllFiles = ({
  dueInDayClick = false,
  fullQcClick = false,
  qcClick = false,
  legalClick = false,
  setFullQcClick,
  setQcClick,
  setDueInDayClick,
  setDueInHalfDayClick,
  setLegalClick,
  filterClientData,
  setFilterClientData,
  filterVendorData,
  setFilterVendorData,
  filterLanguageData,
  setFilterLanguageData,
  filterServiceData,
  setFilterServiceData,
  handleFilter,
  handleFilterClear,
  handleCloseProofReaderAllFileFilter,
  setProofReaderAllFileFilterModal,
  proofReaderAllFileFilterModal,
  filterApiCall,
  setFilterApiCall,
  currentPage,
  setCurrentPage,
  setClaimFile,
  filterFilesStatusData,
  setFilterFilesStatusData,
  isFilterApplied,
}) => {
  usePageTitle('Datagain Transcription  - Files > All Files'); // Set tab title

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userInfo = getUserInfo();
  const debounceTimer = useRef(null);
  const [searchValue, setSearchValue] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [sortField, setSortField] = useState('DueIn');
  const [sortOrder, setSortOrder] = useState(1);
  const [proofReaderMyFileMetricsModal, setProofReaderMyFileMetricsModal] = useState(false);

  // Use useLocation hook to listen for route changes
  const location = useLocation();

  // Reset state when the route changes
  useEffect(() => {
    setSearchValue('');
    setRowsPerPage(10);
    setCurrentPage(0);
    setSortField('DueIn');
    setSortOrder(1);
    setProofReaderAllFileFilterModal(false);
    setFilterApiCall(false);
    setFilterClientData('');
    setFilterVendorData('');
    setFilterLanguageData('');
    setFilterServiceData('');
    setProofReaderMyFileMetricsModal(false);
  }, [location]); // Dependency array listens for route changes

  const handleOpenProofReaderMyFileMetrics = (id) => {
    dispatch(resetMyMetricsData());
    if (id) {
      setProofReaderMyFileMetricsModal(true);
      dispatch(myMetricsRequest(id));
    }
  };

  const handleCloseProofReaderMyFileMetrics = () => {
    setProofReaderMyFileMetricsModal(false);
  };

  // All file's Data
  let proofreaderFileFilterList = useSelector((state) => state?.proofreaderFilesFilterList?.user?.data?.value);

  let proofreaderAllFileList = useSelector((state) => state?.proofreaderAllFilesList?.user?.data?.value);

  let filterDataFile = proofreaderFileFilterList && JSON.parse(proofreaderFileFilterList);

  let proofreaderAllFileTable = proofreaderAllFileList && JSON.parse(proofreaderAllFileList);

  // Api's loading
  const loading = useSelector((state) => state?.proofreaderAllFilesList?.loading);

  const handleSearch = (event) => {
    const value = event.target.value;
    setSearchValue(value);

    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    debounceTimer.current = setTimeout(() => {
      setCurrentPage(0);
      setFilterApiCall(true);
      if (value)
        trackEvent('file_search', {
          query: value,
          page: 'all_files',
        });
    }, 2000);
  };

  // Table data sorting function
  const handleSortChange = (event) => {
    setSortField(event.sortField);
    setSortOrder(event.sortOrder);
    setCurrentPage(0);
    setFilterApiCall(true);
  };
  const handleCopyToClipboard = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        toast.success('Copied to clipboard');
      })
      .catch((err) => {
        toast.error('Failed to copy to clipboard');
      });
  };

  // Dashboard data set for use this function
  useEffect(() => {
    dispatch(
      proofreaderFilesFilterRequest({
        UserId: userInfo?.UserId,
        isMyFiles: false,
      }),
    );
    setFilterApiCall(false);
  }, [dispatch]);

  // Table data set for use this function
  const fetchFiles = useCallback(() => {
    if (filterApiCall) {
      var params = {
        page: currentPage + 1,
        rowNumber: rowsPerPage,
        sortRowName: sortField,
        sortRowDirection: sortOrder === 1 ? 'asc' : 'desc',
        search: searchValue,
        isFullQC: fullQcClick,
        isQC: qcClick,
        isLegal: legalClick,
        isDueInaDay: dueInDayClick,
        isDueInaHalfDay: false,
        filter: {
          clientId: filterClientData === '' ? null : filterClientData,
          serviceType: filterServiceData,
          userId: userInfo?.UserId,
          vendorId: filterVendorData === '' ? null : filterVendorData,
          language: filterLanguageData,
          status: '',
        },
      };
      dispatch(proofreaderAllFilesRequest(params));
      setFilterApiCall(false);
    }
  }, [
    dispatch,
    currentPage,
    rowsPerPage,
    sortField,
    sortOrder,
    searchValue,
    dueInDayClick,
    legalClick,
    qcClick,
    fullQcClick,
    filterApiCall,
  ]);

  // Main useEffect for standard cases (pagination, sorting, filtering changes)
  useEffect(() => {
    fetchFiles();
  }, [fetchFiles]);

  const handleShowProofReaderAllFileFilter = () => {
    setProofReaderAllFileFilterModal(true);
  };

  // Custom body template for all file name on column
  const proofreaderAllFilesTemplate = (rowData, { isRowHovered }) => {
    return (
      <div>
        <Dropdown as={NavItem} className="position-static">
          <Dropdown.Toggle as={NavLink} className="nav-user">
            <div className="d-flex align-items-center">
              <span className="table-folder-icon">
                <FolderOutlinedIcon className="fnt-20" />
              </span>
              <Button id="fade-button">
                <span className="table-link cursor-pointer fnt-14">
                  <CustomTooltips title={rowData?.UserFileName} placement="bottom">
                    <span className="cursor-pointer" style={{ userSelect: 'text' }}>
                      {truncateString(rowData?.UserFileName, 25)}
                    </span>{' '}
                    {rowData?.isLegal && <img src={star_icon} alt="legal" />}
                    {rowData?.IsFullQC && <img src={check_yellow_icon} alt="QC" />}
                  </CustomTooltips>
                  <CustomTooltips title="Copy to clipboard" placement="top">
                    <ContentCopyIcon
                      style={{
                        fontSize: '16px',
                        color: '#1285df',
                        cursor: 'pointer',
                        visibility: isRowHovered && rowData?.UserFileName ? 'visible' : 'hidden',
                        marginLeft: '4px',
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        handleCopyToClipboard(rowData?.UserFileName);
                      }}
                    />
                  </CustomTooltips>
                </span>
              </Button>
            </div>
          </Dropdown.Toggle>
          <Dropdown.Menu className="file-toggle-box">
            <div className="file-info-header">
              <h6 className="fnt-16 fw-semibold mb-0">File Information</h6>
            </div>
            <ul className="file-list-ul">
              {rowData?.VendorLevel && (
                <li>
                  Vendor Level <span className="file-list-content">: {rowData?.VendorLevel}</span>
                </li>
              )}
              {rowData?.CompanyName && (
                <li>
                  Company Name <span className="file-list-content">: {rowData?.CompanyName}</span>
                </li>
              )}
              {rowData?.AudioLanguage && (
                <li>
                  Audio Language <span className="file-list-content">: {rowData?.AudioLanguage}</span>
                </li>
              )}
              {rowData?.Originalvendorname && (
                <li>
                  Original Vendor <span className="file-list-content">: {rowData?.Originalvendorname}</span>
                </li>
              )}
              {rowData?.ServiceType && (
                <li>
                  Service <span className="file-list-content">: {rowData?.ServiceType}</span>
                </li>
              )}
              {rowData?.ProjectManager && (
                <li>
                  Project Manager <span className="file-list-content">: {rowData?.ProjectManager}</span>
                </li>
              )}
              {(rowData?.VerbatimTranscription || rowData?.PII) && (
                <li>
                  Options{' '}
                  <span className="file-list-content">
                    :{' '}
                    {[rowData?.VerbatimTranscription && 'Verbatim', rowData?.PII && 'Redact']
                      .filter(Boolean)
                      .join(', ')}
                  </span>
                </li>
              )}
            </ul>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  };

  const clientNameTemplate = (rowData, { isRowHovered }) => {
    return (
      <>
        {rowData?.ClientName !== null ? (
          <div>
            {rowData?.ClientName}
            <CustomTooltips title="Copy to clipboard" placement="top">
              <ContentCopyIcon
                style={{
                  fontSize: '16px',
                  color: '#1285df',
                  cursor: 'pointer',
                  visibility: isRowHovered && rowData?.ClientName ? 'visible' : 'hidden',
                  marginLeft: '8px',
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleCopyToClipboard(rowData?.ClientName);
                }}
              />
            </CustomTooltips>
          </div>
        ) : (
          <div>--</div>
        )}
      </>
    );
  };

  const centerToast = () => {
    toast(
      'This is level 1 vendor. Please make sure to check the entire transcript before you submit it to the client.',
      {
        position: 'top-center',
        style: {
          fontSize: '20px',
          fontWeight: 400,
        },
      },
    );
  };

  // Custom body template for action on column
  const actionTemplate = (rowData) => {
    return (
      <Button
        variant="primary"
        style={{ padding: 'auto' }}
        onClick={() => {
          if (rowData?.VendorLevel === 'Level 1') {
            centerToast();
          }
          if (rowData?.Id !== null && rowData?.Id !== undefined) {
            setClaimFile(true);
            trackEvent('file_claim', {
              file_id: rowData?.Id,
              file_name: rowData?.UserFileName,
            });
            trackEvent('work_started', {
              file_id: rowData?.Id,
              file_name: rowData?.UserFileName,
            });
            setFilterApiCall(true);
            const url = rowData?.Id ? `/editor-copy/${rowData?.Id}` : DASHBOARD_ROUTE;
            console.log('url', url);
            navigate(url);
          }
        }}
      >
        Claim
      </Button>
    );
  };

  // Custom body template for Vendor Name on column
  const vendorNameTemplate = (rowData, { isRowHovered }) => {
    return (
      <>
        {rowData?.VendorName !== null ? (
          <div
            style={{ color: '#1285df', cursor: 'pointer' }}
            onClick={() => handleOpenProofReaderMyFileMetrics(rowData?.VendorId)}
          >
            {rowData?.VendorName}
            <CustomTooltips title="Copy to clipboard" placement="top">
              <ContentCopyIcon
                style={{
                  fontSize: '16px',
                  color: '#1285df',
                  cursor: 'pointer',
                  visibility: isRowHovered && rowData?.VendorName ? 'visible' : 'hidden',
                  marginLeft: '8px',
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleCopyToClipboard(rowData?.VendorName);
                }}
              />
            </CustomTooltips>
          </div>
        ) : (
          <div>--</div>
        )}
      </>
    );
  };

  // Custom body template for Vendor CompanyName on column
  const companyNameTemplate = (rowData) => {
    return <>{rowData?.CompanyName !== null ? <div>{rowData?.CompanyName}</div> : <div>--</div>}</>;
  };

  const dueInTemplate = (rowData) => {
    const dueDate = rowData?.DueDate;
    const formattedDate = moment(dueDate).format('MM/DD/YYYY');
    const formatDiff = () => {
      const diff = getDaysDiff(dueDate);
      if (diff === 0) return 'Today';
      else if (diff > 0) return 'In ' + diff + ' days';
      else if (diff < 0) return Math.abs(diff) + ' days ago';
    };
    return (
      <div
        style={{
          color: getDaysDiff(dueDate) < 0 ? '#ef3131' : 'unset',
          fontWeight: getDaysDiff(dueDate) === 0 ? 600 : 400,
        }}
      >
        {formatDiff()} ({formattedDate})
      </div>
    );
  };

  const statusTemplate = (rowData) => {
    const statusColors = {
      Rework: '#b76e00',
      Claimed: '#d92d20',
      ProofReading: '#316ea0',
      Proofreading: '#316ea0',
      Review: '#1a7f5a',
      Failed: '#9b0000',
      Submitted: '#5c6f00',
      InProgress: '#6b32ca',
      Uploaded: '#002855',
      Processing: '#5c4a75',
      Completed: '#47590a',
    };

    const color = statusColors[rowData?.Status];

    return <span style={{ color }}>{rowData?.Status}</span>;
  };

  // Modification table cell
  const bodyTemplates = {
    UserFileName: proofreaderAllFilesTemplate,
    ForeignLanguage: foreignLanguageTemplate,
    VendorName: vendorNameTemplate,
    ClientName: clientNameTemplate,
    Action: actionTemplate,
    CompanyName: companyNameTemplate,
    LegalCategory: legalCategoryTemplate,
    DueIn: dueInTemplate,
    Status: statusTemplate,
  };

  let loadingMetrics = useSelector((state) => state?.myMetrics?.loading);

  let myMetricsDataTable = useSelector((state) => state?.myMetrics?.user?.data?.value);

  let myMetrics = myMetricsDataTable && JSON.parse(myMetricsDataTable)?.MyMetrics;

  let ratingMetrics = myMetricsDataTable && JSON.parse(myMetricsDataTable)?.RatingMetrics;

  const selectStyles = {
    control: (base) => ({
      ...base,
      height: '50px',
      minWidth: '200px',
      border: '1px solid #e6e6e6',
      borderRadius: '4px',
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999, // Ensure the dropdown is above the modal
    }),
  };

  return (
    <span>
      <Row>
        <Col className="d-flex align-items-center">
          <div className="mainTitle">
            <Breadcrumb>
              <Breadcrumb.Item>
                {!fullQcClick && !qcClick && !legalClick && !dueInDayClick && (
                  <span
                    onClick={() => {
                      navigate(ALL_FILE_ROUTE);
                      setFullQcClick(false);
                      setQcClick(false);
                      setDueInDayClick(false);
                      setDueInHalfDayClick(false);
                      setLegalClick(false);
                      navigate(ALL_FILE_ROUTE);
                    }}
                  >
                    All Files
                  </span>
                )}
                {dueInDayClick && (
                  <>
                    <span
                      onClick={() => {
                        navigate(ALL_FILE_ROUTE);
                        setFullQcClick(false);
                        setQcClick(false);
                        setDueInDayClick(false);
                        setDueInHalfDayClick(false);
                        setLegalClick(false);
                        navigate(ALL_FILE_ROUTE);
                      }}
                    >
                      All Files
                    </span>
                    <NavigateNextIcon /> Files Due in 24Hrs
                  </>
                )}
                {fullQcClick && (
                  <>
                    <span
                      onClick={() => {
                        navigate(ALL_FILE_ROUTE);
                        setFullQcClick(false);
                        setQcClick(false);
                        setDueInDayClick(false);
                        setDueInHalfDayClick(false);
                        setLegalClick(false);
                        navigate(ALL_FILE_ROUTE);
                      }}
                    >
                      All Files
                    </span>
                    <NavigateNextIcon /> Full QC Files
                  </>
                )}
                {qcClick && (
                  <>
                    <span
                      onClick={() => {
                        navigate(ALL_FILE_ROUTE);
                        setFullQcClick(false);
                        setQcClick(false);
                        setDueInDayClick(false);
                        setDueInHalfDayClick(false);
                        setLegalClick(false);
                        navigate(ALL_FILE_ROUTE);
                      }}
                    >
                      All Files
                    </span>
                    <NavigateNextIcon /> QC Files
                  </>
                )}
                {legalClick && (
                  <>
                    <span
                      onClick={() => {
                        navigate(ALL_FILE_ROUTE);
                        setFullQcClick(false);
                        setQcClick(false);
                        setDueInDayClick(false);
                        setDueInHalfDayClick(false);
                        setLegalClick(false);
                        navigate(ALL_FILE_ROUTE);
                      }}
                    >
                      All Files
                    </span>
                    <NavigateNextIcon /> Legal Files
                  </>
                )}
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </Col>
        <Col md="auto" className="d-flex align-items-center mb-3 gap-3">
          <Form className="search-group main-search-group">
            <Form.Group className="search-group" controlId="exampleForm.ControlInput1">
              <Form.Control
                className="border-0"
                type="text"
                placeholder="Search"
                onChange={handleSearch}
                onKeyDown={(e) => {
                  if (e.keyCode === 13 || e.key === 'Enter') {
                    e.preventDefault();
                  }
                }}
                autoComplete="off"
              />
              <span>
                <SearchRoundedIcon />
              </span>
            </Form.Group>
          </Form>
          <button
            className="filter-btn cursor-pointer"
            onClick={handleShowProofReaderAllFileFilter}
            style={{ background: 'transparent' }}
          >
            <Badge color="primary" variant="dot" invisible={!isFilterApplied}>
              <TuneRoundedIcon />
            </Badge>
          </button>
        </Col>
      </Row>
      <Row>
        <Col xs="12" style={{ marginBottom: 50 }}>
          <div className="card-widget">
            <CustomTable
              tableData={allFilesDashboardProofreaderTableData}
              filteredCustomers={proofreaderAllFileTable ? proofreaderAllFileTable?.Files : []}
              totalRecords={proofreaderAllFileTable?.NoOfRecords}
              rowsPerPage={rowsPerPage}
              sortOrder={sortOrder}
              sortField={sortField}
              setRowsPerPage={setRowsPerPage}
              handleSortChange={handleSortChange}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              setFilterApiCall={setFilterApiCall}
              loading={loading}
              checkbox={false}
              bodyTemplates={bodyTemplates}
              pageName="Dashsboard"
            />
          </div>
        </Col>
      </Row>
      <Modal
        show={proofReaderAllFileFilterModal}
        onHide={handleCloseProofReaderAllFileFilter}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName="custom-modal"
      >
        <div>
          <div className="preview-dropdown-header">
            Filter By
            <HighlightOffRoundedIcon
              onClick={handleCloseProofReaderAllFileFilter}
              className="cursor-pointer opacity-50"
              style={{ height: '28px', width: '28px' }}
            />
          </div>
          <div className="preview-dropdown-body">
            <Row>
              <Col md="6" className="mb-3">
                <label>Client</label>
                <Select
                  value={
                    filterClientData
                      ? {
                        value: filterClientData,
                        label: filterDataFile?.UserList.find((option) => option.Id === filterClientData)?.Name,
                      }
                      : { value: '', label: 'Show All' }
                  }
                  onChange={(selectedOption) => setFilterClientData(selectedOption ? selectedOption.value : '')}
                  options={[
                    { value: '', label: 'Show All' },
                    ...(filterDataFile?.UserList?.map((option) => ({
                      value: option.Id,
                      label: option.Name,
                    })) || []),
                  ]}
                  isSearchable
                  placeholder="Select Client"
                  styles={selectStyles}
                  classNamePrefix="custom-select"
                  menuPortalTarget={document.body} // Render dropdown outside the modal
                />
              </Col>

              <Col md="6" className="mb-3">
                <label>Vendor</label>
                <Select
                  value={
                    filterVendorData
                      ? {
                        value: filterVendorData,
                        label: filterDataFile?.VendorList.find((option) => option.Id === filterVendorData)?.Name,
                      }
                      : { value: '', label: 'Show All' }
                  }
                  onChange={(selectedOption) => setFilterVendorData(selectedOption ? selectedOption.value : '')}
                  options={[
                    { value: '', label: 'Show All' },
                    ...(filterDataFile?.VendorList?.map((option) => ({
                      value: option.Id,
                      label: option.Name,
                    })) || []),
                  ]}
                  isSearchable
                  placeholder="Select Vendor"
                  styles={selectStyles}
                  classNamePrefix="custom-select"
                  menuPortalTarget={document.body} // Render dropdown outside the modal
                />
              </Col>

              <Col md="6" className="mb-3">
                <label>Language</label>
                <Select
                  value={
                    filterLanguageData
                      ? {
                        value: filterLanguageData,
                        label: filterDataFile?.LanguageList.find((option) => option.Name === filterLanguageData)
                          ?.Name,
                      }
                      : { value: '', label: 'Show All' }
                  }
                  onChange={(selectedOption) => setFilterLanguageData(selectedOption ? selectedOption.value : '')}
                  options={[
                    { value: '', label: 'Show All' },
                    ...(filterDataFile?.LanguageList?.map((option) => ({
                      value: option.Name,
                      label: option.Name,
                    })) || []),
                  ]}
                  isSearchable
                  placeholder="Select Language"
                  styles={selectStyles}
                  classNamePrefix="custom-select"
                  menuPortalTarget={document.body} // Render dropdown outside the modal
                />
              </Col>
              <Col md="6" className="mb-3">
                <label>Service</label>
                <Form.Select
                  aria-label="Default select example"
                  value={filterServiceData}
                  onChange={(e) => setFilterServiceData(e.target.value)}
                >
                  <option value="">Select Service</option>
                  {filterDataFile &&
                    filterDataFile?.ServiceList.map((option, index) => (
                      <option key={index} value={option.Id}>
                        {option.Name}
                      </option>
                    ))}
                </Form.Select>
              </Col>
              {/* <Col md="6" className="mb-3">
                <StatusDropdown
                  filterFilesStatusData={filterFilesStatusData}
                  setFilterFilesStatusData={setFilterFilesStatusData}
                  isShowCompleted={false}
                />
              </Col> */}
              <Col md="12" className="text-end mt-5">
                <Button
                  variant="outline-secondary"
                  onClick={handleFilterClear}
                  className="me-2"
                  style={{ height: '45.49px', fontWeight: 600 }}
                >
                  Clear Filter
                </Button>
                <Button
                  variant="primary"
                  onClick={() => {
                    trackEvent('file_filter', {
                      page: 'all_files',
                      client: filterClientData,
                      vendor: filterVendorData,
                      language: filterLanguageData,
                      service: filterServiceData,
                      status: filterFilesStatusData,
                    });
                    handleFilter();
                  }}
                  className="ms-2"
                  style={{ height: '45.49px', fontWeight: 600 }}
                >
                  Filter
                </Button>
              </Col>
            </Row>
          </div>
        </div>
      </Modal>
      <Modal
        show={proofReaderMyFileMetricsModal}
        onHide={handleCloseProofReaderMyFileMetrics}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName="custom-modal"
      >
        <div>
          <div className="preview-dropdown-header">
            Metrics
            <HighlightOffRoundedIcon
              onClick={handleCloseProofReaderMyFileMetrics}
              className="cursor-pointer opacity-50"
              style={{ height: '28px', width: '28px' }}
            />
          </div>
          <div className="preview-dropdown-body">
            <div
              className="text-end"
              onClick={() => window.open(FAQ, '_blank')}
              style={{
                textDecoration: 'underline',
                color: '#190041',
                cursor: 'pointer',
                marginBottom: '6px',
              }}
            >
              FAQ
            </div>
            <div className="mb-4">
              <div className="card-widget">
                <CustomTable
                  tableData={myStatsTableData}
                  filteredCustomers={myMetrics ? myMetrics : []}
                  loading={loadingMetrics}
                  checkbox={false}
                  pagination={false}
                />
              </div>
            </div>
            <div className="mb-3">
              <div className="card-widget">
                <RatingMetrics loading={loading} ratingMetrics={ratingMetrics} />
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </span>
  );
};

export default AllFiles;
